import { IonFab, IonIcon } from '@ionic/react'
import { chevronUpOutline } from 'ionicons/icons'
import { useCallback } from 'react'
import { Button } from './styled'

type ScrollToTopButtonProps = {
  contentRef: React.RefObject<HTMLIonContentElement>
  isVisible: boolean
}

export function ScrollToTopButton({
  contentRef,
  isVisible,
}: ScrollToTopButtonProps) {
  const handleScrollToTop = useCallback(() => {
    contentRef.current?.scrollToTop?.(500)
  }, [contentRef])

  return (
    <IonFab slot='fixed' vertical='bottom' horizontal='end'>
      <Button
        onClick={handleScrollToTop}
        size='small'
        style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'scale(1)' : 'scale(0)',
          pointerEvents: isVisible ? 'auto' : 'none',
        }}
      >
        <IonIcon icon={chevronUpOutline} />
      </Button>
    </IonFab>
  )
}
